import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=14b005bf"
import script from "./main-header.ts?vue&type=script&lang=src&external"
export * from "./main-header.ts?vue&type=script&lang=src&external"
import style0 from "./main-header.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports